import React from 'react';
import './Sakura.css';

const petals = [
  { left: '2%',  size: 10, dur: 9,  delay: 0    },
  { left: '8%',  size: 14, dur: 11, delay: 2    },
  { left: '15%', size: 8,  dur: 7,  delay: 4.5  },
  { left: '22%', size: 12, dur: 13, delay: 1    },
  { left: '28%', size: 9,  dur: 8,  delay: 7    },
  { left: '35%', size: 15, dur: 10, delay: 3    },
  { left: '42%', size: 11, dur: 12, delay: 5    },
  { left: '50%', size: 8,  dur: 9,  delay: 0.5  },
  { left: '57%', size: 13, dur: 7,  delay: 8    },
  { left: '63%', size: 10, dur: 11, delay: 2.5  },
  { left: '70%', size: 9,  dur: 14, delay: 6    },
  { left: '75%', size: 12, dur: 8,  delay: 1.5  },
  { left: '82%', size: 11, dur: 10, delay: 4    },
  { left: '88%', size: 8,  dur: 13, delay: 9    },
  { left: '93%', size: 14, dur: 7,  delay: 3.5  },
  { left: '5%',  size: 11, dur: 12, delay: 11   },
  { left: '18%', size: 9,  dur: 9,  delay: 13   },
  { left: '45%', size: 13, dur: 11, delay: 10   },
  { left: '68%', size: 10, dur: 8,  delay: 12   },
  { left: '90%', size: 12, dur: 10, delay: 14   },
];

function Sakura() {
  return (
    <div className="sakura-container" aria-hidden="true">
      {petals.map((petal, i) => (
        <div
          key={i}
          className="sakura-petal"
          style={{
            left: petal.left,
            width: petal.size + 'px',
            height: Math.round(petal.size * 1.25) + 'px',
            animationDuration: petal.dur + 's',
            animationDelay: petal.delay + 's',
          }}
        />
      ))}
    </div>
  );
}

export default Sakura;
